"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentDataArgs = exports.init = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const get_data_args_1 = require("./get-data-args");
Object.defineProperty(exports, "getComponentDataArgs", { enumerable: true, get: function () { return get_data_args_1.getDataArgs; } });
// TODO this could have a better name
function init(resources, 
/** Hook into data load functions */
wrapLoad) {
    const useComponentData = resources.registerResource('component-data-loader', ({ dataDefinitionArgs, dataDefinition, layout, resourceType, paramsCacheKey, ...services }) => {
        const loadFn = wrapLoad ? wrapLoad(dataDefinition.loadData) : dataDefinition.loadData;
        return loadFn(dataDefinitionArgs, services, {
            resourceType,
            paramsCacheKey,
        });
    }, ['dataDefinitionArgs']);
    function DataLoaderWithRuntimeParams({ dataDefinition, componentProps, services, next, middlewareProps, }) {
        const dataDefinitionArgs = {
            ...componentProps.dataDefinitionArgs,
            ...dataDefinition.useRuntimeParams(componentProps.dataDefinitionArgs, services.services),
        };
        componentProps = { ...componentProps, dataDefinitionArgs };
        const renderProps = useComponentData({
            dataDefinition,
            dataDefinitionArgs,
            layout: services.layout,
        });
        if (!renderProps.lastAction.success) {
            // We have failed to load data, use error boundaries
            // to send error back up and render error page
            throw renderProps.lastAction.error;
        }
        const data = renderProps.data.hasData
            ? { data: { loaded: true, result: renderProps.data.result } }
            : { data: { loaded: false } };
        return (next({
            ...componentProps,
            ...data,
        }, middlewareProps, services) || null);
    }
    function WithDataLoad({ dataDefinition, props, services, next, middlewareProps, }) {
        const dataDefinitionArgs = props.dataDefinitionArgs;
        const renderProps = useComponentData({
            dataDefinition,
            dataDefinitionArgs,
            layout: services.layout,
        });
        if (!renderProps.lastAction.success) {
            // We have failed to load data, use error boundaries
            // to send error back up and render error page
            throw renderProps.lastAction.error;
        }
        const data = renderProps.data.hasData
            ? { data: { loaded: true, result: renderProps.data.result } }
            : { data: { loaded: false } };
        return (next({
            ...props,
            ...data,
        }, middlewareProps, services) || null);
    }
    return {
        createRegisterableComponentWithData: function createRegisterableComponentWithData(type, dataDefinition, render) {
            // This is quite a complex transform which can't be modelled in typescript.
            //
            // The dataDefinition which is passed to this object is hidden from the types returned
            // The content area renderer has a data loader which will look for this property
            // Then use the loadData function
            const normalRender = ({ data, dataDefinitionArgs, ...rest }, services) => {
                return render(rest, {
                    ...data,
                    dataDefinitionArgs,
                }, services);
            };
            const registrationWithData = { type, render: normalRender, dataDefinition };
            // Once the data is loaded it will be passed to the render function on the
            // data prop, which will be typed as LoadedData<TData>
            // The route info looks like this:
            // { type: TType, props: TProps & { dataDefinition: TData } }
            return registrationWithData;
        },
        createRegisterableCompositionWithData: () => (type, dataDefinition, render) => {
            // This is quite a complex transform which can't be modelled in typescript.
            //
            // The dataDefinition which is passed to this object is hidden from the types returned
            // The content area renderer has a data loader which will look for this property
            // Then use the loadData function
            const normalRender = (contentAreas, { data, dataDefinitionArgs, ...rest }, services) => {
                return render(contentAreas, rest, {
                    ...data,
                    dataDefinitionArgs,
                }, services);
            };
            const registrationWithData = { type, render: normalRender, dataDefinition };
            // Once the data is loaded it will be passed to the render function on the
            // data prop, which will be typed as LoadedData<TData>
            // The route info looks like this:
            // { type: TType, props: TProps & { dataDefinition: TData } }
            return registrationWithData;
        },
        getMiddleware: (type) => (props, middlewareProps, services, next) => {
            const registration = type === 'component'
                ? services.layout.componentRegistrations.get(props.layoutType)
                : services.layout.compositionRegistrations.get(props.layoutType);
            // No registration found for this component.
            if (!registration) {
                return next(props, middlewareProps, services);
            }
            const dataDefinition = get_data_args_1.getDataArgs(registration);
            // dataDefinition does not exist on all components.
            if (!dataDefinition) {
                return next(props, middlewareProps, services);
            }
            if (dataDefinition.useRuntimeParams) {
                return (react_1.default.createElement(DataLoaderWithRuntimeParams, { dataDefinition: dataDefinition, componentProps: props, services: services, next: next, middlewareProps: middlewareProps }));
            }
            else {
                return (react_1.default.createElement(WithDataLoad, { dataDefinition: dataDefinition, props: props, services: services, next: next, middlewareProps: middlewareProps }));
            }
        },
    };
}
exports.init = init;
//# sourceMappingURL=index.js.map